import React, { useEffect, useRef } from "react";
import svg9 from "../../assets/svg/svg9.svg";
import svg10 from "../../assets/svg/svg10.svg";
import landingBusiness from "../../assets/img/landing-business-side.png";
import mpesa from "../../assets/img/mpesa.png";
import dtb from "../../assets/img/dtb.png";
import pesalink from "../../assets/svg/pesalink.svg";
import nabo from "../../assets/svg/nabo.svg";
import svg172 from "../../assets/svg/svg172.svg";
import dashboardsvg from "../../assets/svg/Dashboard-impala.svg";
import svg191 from "../../assets/svg/svg191.svg";
import svg192 from "../../assets/svg/svg192.svg";
import { useNavigate, Link } from "react-router-dom";

function Hero() {
 
  const navigate = useNavigate();
 

  const handleLogin = async () => {
    window.location.href = "https://app.impaladigitalpayment.com/#/login";
  };

  const handleRegister = async () => {
    window.location.href = "https://app.impaladigitalpayment.com/#/registration";
  };

  const handleDownload = () => {
    window.location.href = "https://api.impaladigitalpayment.com/api/images/app-release.apk";
  };
  return (
    <>
      <div className="">
        <div className="lg:px-[4.62rem] px-[2rem] pt-[1.5rem] pb-[4rem] flex flex-col items-center font-lexend gap-[1.25rem]">
          {/* Heading */}
          <div className="text-ink text-center text-[1.5rem] lg:text-[2.5rem] font-medium leading-0 tracking-[-0.06rem] max-w-[43rem]">
            Stop Losing Money, Track Every Payment &amp; Expense in One System.
          </div>

          {/* Subtext */}
          <div className="text-body mt-[1rem] text-center font-poppins text-[1rem] font-normal leading-[150%] max-w-[32rem]">
            Pay staff, manage petty cash, and track expenses in real time no
            spreadsheets, no losses.
          </div>

          {/* CTAs */}
          <div className="flex flex-wrap items-center justify-center gap-[.75rem] mt-[1rem]">
            <button
              className="cstm-btn-2 !w-auto !min-w-0 group transition-all duration-500 ease-in-out"
              onClick={() => navigate("/request-demo")}
            >
              Request a demo
              <img
                src={svg10}
                alt="svg10"
                className="w-4 h-3 overflow-hidden opacity-0 group-hover:w-[1.25rem] group-hover:opacity-100 group-hover:ml-[.375rem] transition-all duration-500 ease-in-out"
              />
            </button>
            <button
              className="cstm-btn !min-w-[10rem] !w-auto"
              onClick={() => window.open("https://wa.me/254716644981", "_blank")}
            >
              Chat On WhatsApp <img src={svg172} alt="whatsapp" />
            </button>
          </div>

          <div className="w-full max-w-[70rem] overflow-hidden">
            <img src={dashboardsvg} alt="hero" className="w-full h-auto block" style={{ maxWidth: "100%" }} />
          </div>

          <div className="flex flex-wrap gap-[2rem] lg:gap-[4.44rem] items-center justify-center lg:justify-between  mt-[1rem]">
            <img
              src={dtb}
              alt="dtb"
              className="w-[6rem] lg:w-[9.1875rem] object-contain"
            />
            <img
              src={mpesa}
              alt="mpesa"
              className="w-[5rem] lg:w-[7.125rem] lg:h-[5.1875rem] object-contain"
            />
            <img
              src={pesalink}
              alt="pesalink"
              className="h-[3rem] lg:h-[4.9375rem] lg:w-[7.375rem] object-contain"
            />
            <img
              src={nabo}
              alt="nabo"
              className="w-[3rem] h-[3rem] lg:w-[4.25rem] lg:h-[4.25rem] object-contain"
            />
          </div>
 
          <div className="mt-[1rem] flex flex-col items-center w-full">
            <div className="text-ink text-center font-lexend text-[2rem] lg:text-[3rem] font-[400] leading-normal">
              Get{" "}
              <span style={{
                background: "linear-gradient(180deg, #F7941D 0%, #E8202D 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                fontWeight: 600,
              }}>
                Impala Digital Payments
              </span>{" "}
              App
            </div>
            <div className="text-body text-center font-interSans text-[1rem] lg:text-[1.125rem] font-[400] leading-normal w-full px-3 lg:px-0">
              Access your wallet, send payments, and monitor activity in real time.
            </div>
            <div className="text-body font-lexend text-[1.25rem] lg:text-[1.5rem] font-[400] leading-normal lg:mt-[1.5rem] mt-[1rem]">
              Download App From
            </div>
            <div className="flex flex-wrap items-center justify-center gap-[1.5rem] lg:mt-[3rem] mt-[1.25rem]">
              {[
                { icon: svg191, iconClass: "w-[2.4375rem] h-[2.625rem]", label: "Get it on", store: "Google Play", onClick: handleDownload },
                { icon: svg192, iconClass: "w-[2.25rem] h-[2.6875rem]", label: "Download on the", store: "Apple Store", onClick: null },
              ]?.map((s) => (
                <button key={s?.store} className="store-btn" onClick={s?.onClick}>
                  <img src={s?.icon} alt={s?.store} className={s?.iconClass} />
                  <div className="flex flex-col items-start">
                    <span className="text-white font-interSans text-[0.75rem] font-[400] leading-normal">{s?.label}</span>
                    <span className="text-white font-interSans text-[1.25rem] font-[400] leading-normal">{s?.store}</span>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Hero;
